import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import Vconsole17TabCenter from './Vconsole17TabCenter.vue' 

declareVconsoleComponent('vconsole17TabCenter', Vconsole17TabCenter, 'vconsole17_tab_center:component')